import { h } from 'preact'
// import { usePrerenderData } from '@preact/prerender-data-provider'
import { usePrerenderData } from '../../hooks/use_prerender_data'

import PrerenderError from './error'
import PrerenderLoading from './loading'

const prerender = (RouteComponent) => {
  return (props) => {
    // Preload hook gets confused when there is a query string
    const url = props.url.replace(/\?.*$/, '')
    const [data, loading, error] = usePrerenderData({ url })

    if (data) {
      if (typeof window !== 'undefined' && data.meta) document.title = `${data.meta['og:site_name'].content} | ${data.meta['og:title'].content}`
      return (<RouteComponent data={data} {...props} />)
    } else if (error) {
      return (<PrerenderError error={error} />)
    } else if (loading) {
      return (<PrerenderLoading />)
    }
  }
}

export default prerender
